module.exports = __webpack_public_path__ + "media/images/loghi/banner_legabasket-f20cbca1efaa47f13a33d504ffcb079a.jpg";